import { AppConfigModel } from "../../abstract/app-config.model";

export class LoanPeriodicity extends AppConfigModel {

    static override CLASS_NAME: string = 'LoanPeriodicity';
}
